import { MerchantActionTypes } from './merchant.types'

//Add Merchant
export const addMerchantRequest = data => ({
    type: MerchantActionTypes.ADD_MERCHANT_REQUEST,
    payload: data
})

export const addMerchantRequestSuccess = data => ({
    type: MerchantActionTypes.ADD_MERCHANT_REQUEST_SUCCESS,
    payload: data
})

export const addMerchantRequestError = data => ({
    type: MerchantActionTypes.ADD_MERCHANT_REQUEST_ERROR,
    payload: data
})

export const addMerchantRequestStatus = data => ({
    type: MerchantActionTypes.ADD_MERCHANT_REQUEST_STATUS,
    payload: data
})

//Merchant List
export const merchantListRequest = data => ({
    type: MerchantActionTypes.MERCHANT_LIST_REQUEST,
    payload: data
})

export const merchantListRequestSuccess = data => ({
    type: MerchantActionTypes.MERCHANT_LIST_REQUEST_SUCCESS,
    payload: data
})

export const merchantListRequestError = data => ({
    type: MerchantActionTypes.MERCHANT_LIST_REQUEST_ERROR,
    payload: data
})

//Merchant Detail
export const merchantDetailRequest = data => ({
    type: MerchantActionTypes.MERCHANT_DETAIL_REQUEST,
    payload: data
})

export const merchantDetailRequestSuccess = data => ({
    type: MerchantActionTypes.MERCHANT_DETAIL_REQUEST_SUCCESS,
    payload: data
})

export const merchantDetailRequestError = data => ({
    type: MerchantActionTypes.MERCHANT_DETAIL_REQUEST_ERROR,
    payload: data
})

//Update Merchant Details
export const updateMerchantDetailsRequest = data => ({
    type: MerchantActionTypes.UPDATE_MERCHANT_DETAIL_REQUEST,
    payload: data
})

export const updateMerchantDetailsRequestSuccess = data => ({
    type: MerchantActionTypes.UPDATE_MERCHANT_DETAIL_REQUEST_SUCCESS,
    payload: data
})

export const updateMerchantDetailsRequestError = data => ({
    type: MerchantActionTypes.UPDATE_MERCHANT_DETAIL_REQUEST_ERROR,
    payload: data
})

export const updateMerchantDetailsRequestStatus = data => ({
    type: MerchantActionTypes.UPDATE_MERCHANT_DETAIL_REQUEST_STATUS,
    payload: data
})